export function LoadingView() {
  return (
    <div className="flex min-h-[calc(100vh-32px)] flex-col">
      <div className="flex flex-1 flex-col items-center justify-center gap-4">
        <div className="spinner" />
        <p>Loading customer data...</p>
      </div>
    </div>
  );
}
